var _desc, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinalPosition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10 by 10 orthogonal maze") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "10 by 10 orthogonal maze generated by The Maze Generator Website (https://www.mazegenerator.net/).")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 81.372,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 2,
    x2: 162,
    y2: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.251 17.999 L 98 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 18,
    x2: 146,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 34,
    x2: 130,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 34,
    x2: 162,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.024,
    y1: 66.031,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 50,
    x2: 146,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 66,
    x2: 114,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 66,
    x2: 162,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.856,
    y1: 81.972,
    x2: 66,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 82,
    x2: 98,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 82,
    x2: 146,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 98,
    x2: 82,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 98,
    x2: 114,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 98,
    x2: 146,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.934,
    y1: 113.94,
    x2: 34.027,
    y2: 114.008
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 114,
    x2: 98,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 130,
    x2: 82,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 130,
    x2: 162,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 146,
    x2: 66,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 146,
    x2: 146,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 162,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.274,
    y1: 162.065,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 2.226,
    y2: 145.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 2,
    x2: 18,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 50,
    x2: 18,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.096,
    y1: 97.669,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.957,
    y1: 130.903,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 18,
    x2: 34,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 34,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 114,
    x2: 34,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.931,
    y1: 18.04,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 82,
    x2: 49.919,
    y2: 129.867
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 18,
    x2: 66,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 66,
    x2: 82,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 98,
    x2: 82,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 130,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 82,
    x2: 98,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 114,
    x2: 98,
    y2: 146
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113.971 17.972 C 113.971 23.838 114.023 40.713 114.023 30.847"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 66,
    x2: 114,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 98,
    x2: 114,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 34,
    x2: 130,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 114,
    x2: 130,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 82,
    x2: 146,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.517,
    y1: 17.603,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.217,
    y1: 114.135,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.353,
    y1: 145.094,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 18.107,
    y2: 81.925
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.85,
    y1: 34.067,
    x2: 18,
    y2: 34
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03019, 0, 0, 0.028854, -0.346778, 143.257126)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 5149.086 -4743.895 C 5165.602 -4742.557 5179.909 -4754.828 5181.246 -4771.287 C 5182.525 -4787.745 5170.254 -4802.051 5153.738 -4803.447 C 5137.396 -4804.668 5122.974 -4792.397 5121.752 -4775.939 C 5120.356 -4759.597 5132.627 -4745.175 5149.085 -4743.895"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 5123.786 -4731.625 C 5129.66 -4735.754 5136.813 -4738.487 5144.78 -4737.789 C 5155.016 -4736.975 5163.39 -4730.636 5168.508 -4722.901 L 5198.633 -4663.175 L 5239.749 -4634.853 C 5243.238 -4632.178 5245.448 -4627.817 5244.983 -4623.047 C 5244.401 -4615.662 5237.946 -4610.136 5230.56 -4610.776 C 5228.292 -4610.893 5226.431 -4611.823 5224.395 -4612.754 L 5179.557 -4643.635 C 5178.162 -4644.74 5177.057 -4646.135 5176.126 -4647.589 L 5164.902 -4669.979 L 5151.352 -4610.427 L 5204.332 -4547.851 C 5205.553 -4545.932 5206.368 -4543.664 5206.833 -4541.396 L 5221.139 -4465.851 C 5221.023 -4464.165 5221.255 -4463.118 5221.139 -4461.78 C 5220.325 -4450.498 5210.555 -4442.356 5199.447 -4443.17 C 5190.2 -4443.926 5183.396 -4450.73 5181.244 -4459.163 L 5167.752 -4529.939 L 5124.658 -4577.045 L 5114.713 -4531.16 C 5114.364 -4529.008 5111.515 -4524.472 5110.7 -4522.669 L 5069.351 -4452.998 C 5065.28 -4446.659 5058.359 -4442.588 5050.509 -4443.228 C 5039.285 -4444.042 5030.969 -4453.812 5031.899 -4464.978 C 5032.132 -4468.119 5033.47 -4471.433 5034.633 -4473.702 L 5073.016 -4538.081 L 5105.06 -4679.981 L 5084.124 -4663.058 L 5073.016 -4612.52 C 5071.504 -4606.006 5065.63 -4600.714 5058.71 -4601.238 C 5051.208 -4601.819 5045.741 -4608.274 5046.323 -4615.777 C 5046.323 -4616.358 5046.439 -4616.94 5046.555 -4617.638 L 5059.698 -4676.55 C 5060.512 -4679.05 5061.85 -4681.318 5063.827 -4683.063 L 5123.786 -4731.623 L 5123.786 -4731.625 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalPosition);
export default __webpack_public_path__ + "static/media/FinalPosition.b9021bba3680cee9ac2cceea00ec54a8.svg";
export { ForwardRef as ReactComponent };